import { Button, Flex, Space } from 'antd'
import React from 'react'
import Access from '../access/Access'
import { ContentRules } from '../access/access-rules/assignment-rules'

export const EditPatternModalFooter = ({
    pattern,
    onDeletePattern,
    isWaitingForPatternSave,
    projectionCostDetails,
    criteriaChanged,
    isAssignmentTooBigForProjection,
}) => {
    return (
        <Flex justify='end'>
            <Space>
                <Access rules={ContentRules.EDIT_GRADINGS}>
                    <Button danger onClick={onDeletePattern} disabled={!pattern}>
                        Delete
                    </Button>
                </Access>
                <Access
                    rules={ContentRules.EDIT_NAMINGS}
                >
                    <Button
                        type='primary'
                        htmlType='submit'
                        form='edit-pattern'
                        loading={isWaitingForPatternSave}
                        disabled={!pattern || isAssignmentTooBigForProjection}
                    >
                        Save {criteriaChanged && `${projectionCostDetails}`}
                    </Button>
                </Access>
            </Space>
        </Flex>
    )
}
